import { render } from "./ProfileMoveCard.vue?vue&type=template&id=1847eaa8&scoped=true"
import script from "./ProfileMoveCard.vue?vue&type=script&lang=js"
export * from "./ProfileMoveCard.vue?vue&type=script&lang=js"

import "./ProfileMoveCard.vue?vue&type=style&index=0&id=1847eaa8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1847eaa8"]])

export default __exports__